import axiosClient from "../../http-common";
import { TENANTS_BASE_URL } from "../../constants/routes/api";

class ContainersApiService {
  createContainer = async (tenantId, container) => {
    return axiosClient.post(`${TENANTS_BASE_URL}/${tenantId}/Containers`, container);
  }

  deleteContainer = async (tenantId, containerId) => {
    return axiosClient.delete(`${TENANTS_BASE_URL}/${tenantId}/Containers/${containerId}`);
  }

  getContainersByTenantId = async (tenantId) => {
    return axiosClient.get(`${TENANTS_BASE_URL}/${tenantId}/Containers`);
  }

  updateContainer = async (tenantId, containerId, updateContainerRequest) => {
    return axiosClient.put(`${TENANTS_BASE_URL}/${tenantId}/Containers/${containerId}`, updateContainerRequest
    );
  }

  getAccessibleContainersByTenantId = async (tenantId) => {
    return axiosClient.get(`${TENANTS_BASE_URL}/${tenantId}/Containers`);
  }
}

export default new ContainersApiService();